import { jsx as _jsx } from "react/jsx-runtime";
export const EmojiSvg = ({ children, role = 'img', size = 24, viewBox, ...props }) => {
    return (_jsx("svg", { fill: "none", focusable: false, height: size, role: role, viewBox: viewBox, width: size, ...props, children: children }));
};
//# sourceMappingURL=EmojiSvg.js.map